let messageDigest = [
  'SHA-224',
  'SHA-256',
  'SHA-384',
  'SHA-512'
]

export default messageDigest
